import axios from "axios";

const token = localStorage.getItem('jwt');
const baseUrl = process.env.VUE_APP_API_HOST;

const instance = axios.create({baseURL: baseUrl});
instance.interceptors.request.use(config => {
    config.params = {
        // add your default ones
        token: token,
        // spread the request's params
        ...config.params,
    };
    return config;
});

// Media service instance - same base URL but different path
const mediaInstance = axios.create({baseURL: baseUrl});
mediaInstance.interceptors.request.use(config => {
    config.headers = {
        ...config.headers,
        'Authorization': `Bearer ${token}`,
    };
    return config;
});

export default instance;
export { mediaInstance };